import { SimpleGenList } from '../simpleGenList';

/**
 * Grammatical cases in Czech.
 * Port of C# Seznam_Pady__CS.
 */
export class GenList_Cases__CS extends SimpleGenList {
  constructor() {
    super(
      'kdo, co?',
      '(bez) koho, čeho?',
      '(ke) komu, čemu?',
      '(vidím) koho, co?',
      'oslovujeme, voláme',
      '(o) kom, (o) čem?',
      '(s) kým, čím'
    );
  }
}

/**
 * Grammatical cases in Latin.
 * Port of C# Seznam_Pady__LA.
 */
export class GenList_Cases__LA extends SimpleGenList {
  constructor() {
    super(
      'nominativ',
      'genitiv',
      'dativ',
      'akuzativ',
      'vokativ',
      'lokál',
      'instrumentál'
    );
  }
}
